import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import {
  cloneValue,
  expectObject,
  readObjectArray,
  readStringArray,
  splitKnown,
} from "../utils";
import { ProductVersionFactoryPricingBracketModel } from "./ProductVersionFactoryPricingBracketModel";

export class ProductVersionFactoryPricingExtraColorModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    fabricNames: { label: "Fabric Names", fieldType: "json", minRows: 4 },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  fabricNames!: string[];
  priceBrackets!: ProductVersionFactoryPricingBracketModel[];
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("fabricNames", []);
    this.defineObservableValue("priceBrackets", []);
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(
      snapshot,
      "product factory pricing extra color"
    );
    this.fabricNames = readStringArray(source, "fabricNames");
    this.priceBrackets = readObjectArray(source, "priceBrackets").map((entry) =>
      new ProductVersionFactoryPricingBracketModel().restore(entry)
    );
    this.extra = splitKnown(source, ["fabricNames", "priceBrackets"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.fabricNames.length > 0
        ? { fabricNames: [...this.fabricNames] }
        : {}),
      ...(this.priceBrackets.length > 0
        ? { priceBrackets: this.priceBrackets.map((entry) => entry.save()) }
        : {}),
    };
  }
}
